const $ = require('jquery')
import axios from 'axios';
import Vue from 'vue'
import { URL_BASE } from "../helper/constant.js";

export default {

    getIP() {
        // return axios.get('https://api.ipify.org?format=json')
        return axios.get('https://ipapi.co/json/')
    },
    Login(body) {
        //console.log('body :', body);
        return $.ajax({
            url: `${URL_BASE}/login.php`,
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(body),
            dataType: 'json',
        })
            .done((res) => {
                return res;
            })
            .catch((jqXHR, textStatus, errorThrown) => {
                return { message: errorThrown }
            })
    },

  
}


// WEBPACK FOOTER //
// ./src/services/LoginServices.js